import { useQuery } from "@tanstack/react-query"
import { getBalance } from "@wagmi/core"
import { formatUnits } from "viem"
import { useAccount, useConfig } from "wagmi"

import { BIGINT_ZERO } from "@/domains/on-chain"

import { useNativeToken } from "./use-native-token"

const emptyToken = {
  symbol: "",
  decimals: 18,
  wei: BIGINT_ZERO,
  value: "0",
  price: 0,
  balanceUsdValue: 0,
}

/**
 * Only returns the native balance for a given account, does NOT return token pricing
 *
 * @todo This should watch the wallet for changes and update instantly instead of polling
 */
export const useNativeBalance = () => {
  const config = useConfig()
  const account = useAccount({ config })
  const nativeToken = useNativeToken()

  const balanceQuery = useQuery({
    queryKey: ["native-balance", account.address],
    queryFn: async () => {
      if (!account.address) return emptyToken

      const getBalanceResult = await getBalance(config, { address: account.address })

      const decimals = nativeToken?.decimals ?? 18
      const wei = getBalanceResult.value ?? BIGINT_ZERO
      const value = formatUnits(wei, decimals)

      return {
        symbol: nativeToken?.symbol ?? getBalanceResult.symbol ?? "",
        decimals,
        wei,
        value,
        price: 0, // do not change or use, we will deprecate this type in the library
        balanceUsdValue: 0, // do not change or use, we will deprecate this type in the library
      }
    },
    enabled: !!account,
    initialData: emptyToken,
  })

  return {
    balanceQuery,
    nativeBalance: balanceQuery.data,
  }
}
